import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "./ContextVars";
import translations from "./translations";

// #mod 3/11/26 TG: la imagen ya no se abre por su dirección; se pide con la frase de admin.
const ProofImage = ({ order, passphrase, t }) => {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    let objectUrl = "";
    setUrl("");
    setFailed(false);
    fetch("https://eleven.fit/php/bank-proof.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ passphrase, order }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("proof " + res.status);
        return res.blob();
      })
      .then((blob) => {
        objectUrl = URL.createObjectURL(blob);
        if (alive) setUrl(objectUrl);
      })
      .catch(() => {
        if (alive) setFailed(true);
      });
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [order, passphrase]);

  if (failed) return <p className="margin-top-10 font-size-18 color-gray-3">{t("loadError")}</p>;
  if (!url) return <p className="margin-top-10 font-size-18 color-gray-3">{t("loading")}</p>;
  return (
    <p className="margin-top-10">
      <a href={url} target="_blank" rel="noreferrer">
        {t("viewProof")}
      </a>
      <br />
      <img
        src={url}
        alt="proof"
        style={{ display: "block", margin: "10px auto", maxWidth: "420px", width: "100%", border: "1px solid #fff" }}
      />
    </p>
  );
};

// #added venta manual: registrar ventas fuera del checkout 28/10/26 TG
const MANUAL_URL = "https://eleven.fit/php/bank-manual-transaction.php";
const today = () => new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD in local time
const emptySale = () => ({
  email: "", firstName: "", lastName: "", amount: "", currency: "GTQ", date: today(),
  method: "cash", productId: "", note: "", activate: false, sendEmail: false,
});
const fieldStyle = { color: "#000" };

const ManualSale = ({ passphrase, t }) => {
  const [sale, setSale] = useState(emptySale());
  const [products, setProducts] = useState([]);
  const [recent, setRecent] = useState([]);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  const post = async (body) => {
    const res = await fetch(MANUAL_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ passphrase, ...body }),
    });
    return res.json();
  };

  const loadLists = async () => {
    try {
      const [p, r] = await Promise.all([post({ action: "products" }), post({ action: "recent" })]);
      if (p.success) setProducts(p.data || []);
      if (r.success) setRecent(r.data || []);
    } catch (e) {
      setMsg(t("networkError"));
    }
  };

  useEffect(() => { loadLists(); }, [passphrase]); // eslint-disable-line react-hooks/exhaustive-deps

  const set = (key) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setSale((s) => ({ ...s, [key]: value, ...(key === "productId" && !value ? { activate: false } : {}) }));
  };

  const save = async (e) => {
    e.preventDefault();
    if (!window.confirm(t("manualConfirm"))) return;
    setSaving(true);
    setMsg("");
    try {
      const data = await post({ action: "create", ...sale });
      if (data.success) {
        const act = data.activation ? " " + t("activation_" + data.activation) : "";
        setMsg(`${t("manualSaved")} ${data.orderNumber}.${act}`);
        setSale(emptySale());
        loadLists();
      } else {
        setMsg(data.message || t("networkError"));
      }
    } catch (err) {
      setMsg(t("networkError"));
    }
    setSaving(false);
  };

  const label = (key, child) => (
    <label className="font-size-18 color-gray-3" style={{ display: "block", marginTop: 12 }}>
      {t(key)}
      {child}
    </label>
  );

  return (
    <div className="margin-top-30" style={{ border: "1px solid rgba(255,255,255,0.3)", padding: "20px" }}>
      <h3 className="font-size-24">{t("manualTitle")}</h3>
      <p className="font-size-18 color-gray-3">{t("manualIntro")}</p>
      <form onSubmit={save}>
        {label("manualEmail", <input id="ms-email" type="email" required value={sale.email} onChange={set("email")} className="w-full border p-2" style={fieldStyle} />)}
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 180px" }}>{label("manualFirst", <input id="ms-first" value={sale.firstName} onChange={set("firstName")} className="w-full border p-2" style={fieldStyle} />)}</div>
          <div style={{ flex: "1 1 180px" }}>{label("manualLast", <input id="ms-last" value={sale.lastName} onChange={set("lastName")} className="w-full border p-2" style={fieldStyle} />)}</div>
        </div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <div style={{ flex: "1 1 140px" }}>{label("manualAmount", <input id="ms-amount" type="number" min="0.01" step="0.01" required value={sale.amount} onChange={set("amount")} className="w-full border p-2" style={fieldStyle} />)}</div>
          <div style={{ flex: "0 1 120px" }}>{label("manualCurrency",
            <select id="ms-currency" value={sale.currency} onChange={set("currency")} className="w-full border p-2" style={fieldStyle}>
              <option value="GTQ">GTQ</option>
              <option value="USD">USD</option>
            </select>)}</div>
          <div style={{ flex: "1 1 160px" }}>{label("manualDate", <input id="ms-date" type="date" max={today()} required value={sale.date} onChange={set("date")} className="w-full border p-2" style={fieldStyle} />)}</div>
        </div>
        {label("manualMethod",
          <select id="ms-method" value={sale.method} onChange={set("method")} className="w-full border p-2" style={fieldStyle}>
            <option value="cash">{t("methodCash")}</option>
            <option value="transfer">{t("methodTransfer")}</option>
            <option value="card">{t("methodCard")}</option>
            <option value="other">{t("methodOther")}</option>
          </select>)}
        {label("manualProduct",
          <select id="ms-product" value={sale.productId} onChange={set("productId")} className="w-full border p-2" style={fieldStyle}>
            <option value="">{t("manualNoProduct")}</option>
            {products.map((p) => (
              <option key={p.product_id} value={p.product_id}>{p.name}</option>
            ))}
          </select>)}
        {label("manualNote", <input id="ms-note" value={sale.note} onChange={set("note")} className="w-full border p-2" style={fieldStyle} />)}
        <label className="font-size-18 color-gray-3" style={{ display: "flex", gap: 8, marginTop: 12, opacity: sale.productId ? 1 : 0.5 }}>
          <input id="ms-activate" type="checkbox" checked={sale.activate} disabled={!sale.productId} onChange={set("activate")} />
          {t("manualActivate")}
        </label>
        <label className="font-size-18 color-gray-3" style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <input id="ms-sendemail" type="checkbox" checked={sale.sendEmail} onChange={set("sendEmail")} />
          {t("manualSendEmail")}
        </label>
        <button className="button-2 margin-top-20" type="submit" disabled={saving}>
          {saving ? t("manualSaving") : t("manualSave")}
        </button>
      </form>
      {msg && <p className="margin-top-10 font-size-18 color-gray-3">{msg}</p>}

      <h4 className="font-size-20 margin-top-30">{t("manualRecent")}</h4>
      {recent.length === 0 && <p className="font-size-18 color-gray-3">{t("manualNone")}</p>}
      {recent.map((r) => (
        <p key={r.order_number} className="font-size-18 color-gray-3" style={{ margin: "6px 0" }}>
          {String(r.created_at).slice(0, 10)} · {r.order_number} · {r.first_name} {r.last_name} ({r.email}) ·{" "}
          {r.currency === "GTQ" ? "Q" : "$"}{parseFloat(r.amount || 0).toFixed(2)} · {r.method}
          {r.items ? ` · ${r.items}` : ""}
        </p>
      ))}
    </div>
  );
};

const BankApprovals = () => { // #added página admin para aprobar Transferencias Bancarias 1/8/26 TG
  const { language } = useContext(AppContext);
  const t = (key) => translations.BankAdmin[key]?.[language] || key;

  const [passphrase, setPassphrase] = useState(sessionStorage.getItem("bankAdminPass") || "");
  const [entered, setEntered] = useState(sessionStorage.getItem("bankAdminPass") || "");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [actioning, setActioning] = useState("");

  const load = async (pass) => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch("https://eleven.fit/php/bank-get-pending.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passphrase: pass }),
      });
      const data = await res.json();
      if (data.success) {
        setOrders(data.data || []);
      } else {
        setError(data.message || t("loadError"));
      }
    } catch (e) {
      setError(t("networkError"));
    }
    setLoading(false);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    sessionStorage.setItem("bankAdminPass", entered);
    setPassphrase(entered);
    load(entered);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("bankAdminPass");
    setPassphrase("");
    setEntered("");
    setOrders([]);
  };

  const approve = async (orderNumber) => {
    if (!window.confirm(t("confirmApprove") + " " + orderNumber)) return;
    setActioning(orderNumber);
    try {
      const res = await fetch("https://eleven.fit/php/bank-approve.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passphrase, order: orderNumber }),
      });
      const data = await res.json();
      if (data.success) {
        load(passphrase);
      } else {
        alert(data.message || t("approveError"));
      }
    } catch (e) {
      alert(t("networkError"));
    }
    setActioning("");
  };

  if (!passphrase) {
    return (
      <section className="section-2 overlay tint-black-40">
        <div className="section__content">
          <h2 className="general-title">{t("title")}</h2>
          <form onSubmit={handleLogin} className="max-width-70" style={{ margin: "0 auto" }}>
            <p className="margin-top-20">{t("passphrase")}</p>
            <input
              type="password"
              value={entered}
              onChange={(e) => setEntered(e.target.value)}
              className="w-full border mb-2 p-2"
              style={{ color: "#000" }}
            />
            <button className="button-2 margin-top-10" type="submit">
              {t("enter")}
            </button>
          </form>
          {error && <p className="margin-top-10 font-size-18 color-gray-3">{error}</p>}
        </div>
      </section>
    );
  }

  return (
    <section className="section-2 overlay tint-black-40">
      <div className="section__content">
        <div className="max-width-70" style={{ margin: "0 auto" }}>
          <h2 className="general-title">{t("title")}</h2>
          <button className="button-2 margin-top-10" onClick={handleLogout}>
            {t("logout")}
          </button>
          <button className="button-2 margin-top-10" onClick={() => load(passphrase)}>
            {t("refresh")}
          </button>

          <ManualSale passphrase={passphrase} t={t} />{/* #added venta manual 28/10/26 TG */}

          {loading && <p className="margin-top-20 font-size-20 color-gray-3">{t("loading")}</p>}
          {!loading && error && <p className="margin-top-20 font-size-20 color-gray-3">{error}</p>}
          {!loading && !error && orders.length === 0 && (
            <p className="margin-top-20 font-size-20 color-gray-3">{t("noOrders")}</p>
          )}

          {orders.map((o) => {
            const resp = o.response_data || {};
            return (
              <div key={o.order_number} className="margin-top-30" style={{ border: "1px solid rgba(255,255,255,0.3)", padding: "20px" }}>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("orderNumber")}:</strong> {o.order_number}
                </p>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("created")}:</strong> {o.created_at}
                </p>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("customer")}:</strong> {o.first_name} {o.last_name} ({o.email})
                </p>
                <p className="font-size-20 color-gray-3">
                  <strong>{t("amount")}:</strong> {o.currency === "GTQ" ? "Q" : "$"}
                  {parseFloat(o.amount || 0).toFixed(2)} {o.currency}
                </p>
                {o.items && o.items.length > 0 && (
                  <p className="font-size-20 color-gray-3">
                    <strong>{t("items")}:</strong>{" "}
                    {o.items.map((it) => it.name || it.product_id).join(", ")}
                  </p>
                )}
                <p className="font-size-20 color-gray-3">
                  <strong>{t("status")}:</strong>{" "}
                  {o.status === "pending_approval" ? t("pendingApproval") : t("awaitingProof")}
                </p>

                {resp.bank_reference && (
                  <p className="font-size-20 color-gray-3">
                    <strong>{t("bankRef")}:</strong> {resp.bank_reference}
                  </p>
                )}
                {resp.proof_path && <ProofImage order={o.order_number} passphrase={passphrase} t={t} />}

                {o.status === "pending_approval" && (
                  <button
                    className="button-2 margin-top-20"
                    disabled={actioning === o.order_number}
                    onClick={() => approve(o.order_number)}
                  >
                    {actioning === o.order_number ? t("approving") : t("approve")}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BankApprovals;
